module.exports = __webpack_public_path__ + "img/service-details.e8e84ea2.png";